/* tslint:disable */
/* eslint-disable */
/**
 * Risk Management System API
 * Risk Management System API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ApiFilteredAlert } from './ApiFilteredAlert';
import {
    ApiFilteredAlertFromJSON,
    ApiFilteredAlertFromJSONTyped,
    ApiFilteredAlertToJSON,
    ApiFilteredAlertToJSONTyped,
} from './ApiFilteredAlert';

/**
 * 
 * @export
 * @interface ApiFilteredAlerts
 */
export interface ApiFilteredAlerts {
    /**
     * 
     * @type {Array<ApiFilteredAlert>}
     * @memberof ApiFilteredAlerts
     */
    alerts: Array<ApiFilteredAlert>;
}

/**
 * Check if a given object implements the ApiFilteredAlerts interface.
 */
export function instanceOfApiFilteredAlerts(value: object): value is ApiFilteredAlerts {
    if (!('alerts' in value) || value['alerts'] === undefined) return false;
    return true;
}

export function ApiFilteredAlertsFromJSON(json: any): ApiFilteredAlerts {
    return ApiFilteredAlertsFromJSONTyped(json, false);
}

export function ApiFilteredAlertsFromJSONTyped(json: any, ignoreDiscriminator: boolean): ApiFilteredAlerts {
    if (json == null) {
        return json;
    }
    return {
        
        'alerts': ((json['alerts'] as Array<any>).map(ApiFilteredAlertFromJSON)),
    };
}

export function ApiFilteredAlertsToJSON(json: any): ApiFilteredAlerts {
    return ApiFilteredAlertsToJSONTyped(json, false);
}

export function ApiFilteredAlertsToJSONTyped(value?: ApiFilteredAlerts | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'alerts': ((value['alerts'] as Array<any>).map(ApiFilteredAlertToJSON)),
    };
}

